import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "cross_sale_container container my-2" }
const _hoisted_2 = { class: "row custom_padding_row custom_margin_row" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-lg-9 col-md-9 mx-auto custom_padding_col custom_margin_col"
}

import crossSaleService from "@/services/crossSale";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import CrossSale from "./crossSale.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'crossSaleContainer',
  props: {
    orderID: { default: '' },
    productID: { default: '' },
    crossSaleAdded: { type: [String, Boolean], default: false }
  },
  setup(__props: any) {

const router = useRouter();

// ========================= initialize data =========================
const crossSale = ref([]);
const props = __props;

const isLoading = ref(true);

// =========================== Methods =====================
const getCrossSaleAfterOrder = () => {
  isLoading.value = true;

  // If crossSaleAdded is true, request total order price for pixel tracking
  const useTotalOrderPrice = !!props.crossSaleAdded;

  crossSaleService.getCrossSaleAfterOrder(props.orderID, props.productID, useTotalOrderPrice)
    .then((res: any) => {
      isLoading.value = false;
      let response = res.data.data;

      // Handle cross-sells
      const crossSells = response.cross_sells || response;
      const currentPath = router.currentRoute.value.path;
      const isThankYouPage = currentPath === '/pages/thank';
      const isConfirmationPage = currentPath === '/pages/confirmation';

      if (crossSells.length > 0 && isThankYouPage && !crossSells[0].display_locations.includes('thank_you_page')) {
        crossSale.value = [];
        return;
      }

      if(crossSells.length == 0) {
        crossSale.value = [];
      } else {
        crossSale.value = crossSells;

        // Fire ViewCrossSell event only when cross-sells are displayed on thank you or confirmation page
        if (response.pixel_tracking && (isThankYouPage || isConfirmationPage)) {
          console.log('Firing pixel tracking for cross-sell view');
          fireViewCrossSellEvent(response.pixel_tracking);
        }
      }

    })
    .catch((err: any) => {
      isLoading.value = false;
    });
};

const fireViewCrossSellEvent = (pixelData: any) => {
  const pixelTrackingData = {
    ...pixelData,
    page_url: window.location.href
  };

  console.log('Firing ViewCrossSell event with data:', pixelTrackingData);

  // Facebook Pixel - ViewCrossSell custom event
  if (typeof (window as any).fbq !== 'undefined') {
    try {
      (window as any).fbq('trackCustom', 'ViewCrossSell', pixelTrackingData);
      console.log('Facebook ViewCrossSell event fired');
    } catch (error) {
      console.error('Error firing Facebook ViewCrossSell event:', error);
    }
  }

  // TikTok Pixel - ViewCrossSell custom event
  if (typeof (window as any).ttq !== 'undefined') {
    try {
      const tiktokPixelData = { ...pixelTrackingData };
      if (tiktokPixelData.content_type && tiktokPixelData.content_type !== 'product') {
        tiktokPixelData.content_type = 'product_group';
      }
      (window as any).ttq.track('ViewCrossSell', tiktokPixelData);
      console.log('TikTok ViewCrossSell event fired');
    } catch (error) {
      console.error('Error firing TikTok ViewCrossSell event:', error);
    }
  }
};

const removeOrder = () => {
  crossSale.value = [];

  if (router.currentRoute.value.path === '/pages/confirmation') {  
    const currentQuery = { ...router.currentRoute.value.query };
    router.push({
      path: '/pages/thank',
      query: currentQuery
    });
  }

};
// ========================= onMounted ===================
onMounted(() => {
  getCrossSaleAfterOrder();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (crossSale.value.length > 0 && !props.crossSaleAdded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(CrossSale, {
              sale: crossSale.value[0],
              orderID: _ctx.orderID,
              productID: _ctx.productID,
              onRemove: removeOrder
            }, null, 8, ["sale", "orderID", "productID"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})